import VerificationIcon from '../icons/VerificationIcon'
import Tooltip from './Tooltip'

export default function DisplayShopName({
  shop,
  className = '',
  showBadges = true,
  showIconsOnMobile = true,
  size = 'md',
}) {
  const sizeClasses = {
    sm: {
      text: 'text-sm',
      badge: 'w-3 h-3',
      premium: 'w-3 h-3',
      gap: 'gap-1',
    },
    md: {
      text: 'text-base',
      badge: 'w-4 h-4',
      premium: 'w-4 h-4',
      gap: 'gap-1.5',
    },
    lg: {
      text: 'text-lg',
      badge: 'w-5 h-5',
      premium: 'w-5 h-5',
      gap: 'gap-2',
    },
  }

  const currentSize = sizeClasses[size]

  if (!shop || !shop.name) return

  return (
    <div className={`flex flex-wrap items-center ${currentSize.gap} ${className}`}>
      <span className={` truncate ${currentSize.text}`}>{shop.name}</span>

      {showBadges && (
        <div className={`flex items-center ${currentSize.gap}`}>
          {shop.isPremium && (
            <>
              <img
                src="/premium.png"
                alt="Premium"
                className={`${currentSize.premium} object-contain  aspect-square flex-shrink-0 ${
                  showIconsOnMobile ? 'inline-block' : 'hidden'
                } lg:inline-block`}
                title="This is a premium shop."
              />

              {!showIconsOnMobile && (
                <span title="This is a premium shop. Premium shops are recognized for their exceptional service, quality products, and customer satisfaction.">
                  <span className="lg:hidden text-yellow-600 bg-yellow-100 py-0.5 rounded-md px-2 text-xs">
                    Premium
                  </span>
                </span>
              )}
            </>
          )}

          {shop?.isVerified && (
            <span title="This shop has been verified by Sokooni. Verified shops are trusted sellers who have undergone a thorough verification process to ensure authenticity and reliability.">
              {!showIconsOnMobile && (
                <span className="lg:hidden text-success-600 bg-green-100 py-0.5 rounded-md px-2 text-xs">
                  Verified
                </span>
              )}
              <VerificationIcon
                className={`${currentSize.badge} text-success-600 flex-shrink-0 ${
                  showIconsOnMobile ? 'inline-block' : 'hidden'
                } lg:inline-block`}
              />
            </span>
          )}
        </div>
      )}
    </div>
  )
}
